import { useEffect, useState } from 'react';
import SearchSettingsService from 'services/SearchSettings.service';

/**
 * Hook personalizado para gerenciar configurações de busca do usuário
 * @returns {Object} Objeto contendo as configurações e funções de gerenciamento
 */
const useSearchSettings = () => {
  const [searchSettings, setSearchSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  // Configurações padrão caso a API falhe
  const defaultSettings = {
    searchInSubject: true,
    searchInDescription: true,
    searchInProperties: true,
    searchInNotes: true,
    searchInAttachments: true
  };

  // Carregar configurações do usuário
  const loadSearchSettings = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const settings = await SearchSettingsService.findByUser();
      setSearchSettings(settings);
    } catch (err) {
      console.error('Erro ao carregar configurações de pesquisa:', err);
      setError('Erro ao carregar configurações de pesquisa');
      // Usar configurações padrão em caso de erro
      setSearchSettings(defaultSettings);
    } finally {
      setIsLoading(false);
    }
  };

  // Atualizar configurações
  const updateSearchSettings = async newSettings => {
    try {
      setIsUpdating(true);
      setError(null);

      // Aqui você pode implementar a atualização das configurações
      // se o backend suportar essa funcionalidade
      const updatedSettings = await SearchSettingsService.edit(newSettings);
      setSearchSettings(updatedSettings);
      return { success: true };
    } catch (err) {
      console.error('Erro ao atualizar configurações de pesquisa:', err);
      setError('Erro ao atualizar configurações de pesquisa');
      return { success: false, error: err.message };
    } finally {
      setIsUpdating(false);
    }
  };

  // Resetar para configurações padrão
  const resetToDefault = () => {
    setSearchSettings(defaultSettings);
    setError(null);
  };

  // Carregar configurações na inicialização
  useEffect(() => {
    loadSearchSettings();
  }, []);

  return {
    searchSettings,
    isLoading,
    error,
    isUpdating,
    loadSearchSettings,
    updateSearchSettings,
    resetToDefault,
    defaultSettings
  };
};

export default useSearchSettings;
